import { connect } from 'react-redux';
import _merge from 'lodash.merge';
import MainRouterComponent from './main-router.component';
import * as MainRouterActions from './main-router.actions';

const mapStateToProps = (state, ownProps) => {


    const props = _merge({}, ownProps, {
    	"templates": state.Main.templates
    })
    return props;
};
const mapDispatchToProps = dispatch => {
    return {
    	onReady: (BrowserRouter) => {
    		 dispatch(MainRouterActions.ready(BrowserRouter));
    	}
    }
};

const MainRouter = connect(mapStateToProps, mapDispatchToProps)(MainRouterComponent);
export default MainRouter;
